import {React} from 'react';


const GDPREng = () => {    
 
    return (

        <div className="gdpr-wrap">
            
            <h1>Data protection statement</h1>
                            
            <div>
                <h2 className="important">Concerned domain:</h2>
                <p className="short-text"><a href="index.html" target="_blank">www.farkasgym.hu</a></p>
            </div>

            <div>
                <h2 className="important">Proceded data:</h2>
                <p className="short-text">SESSION</p>
            </div>

            <div>
                <h2 className="important">Type of cookie:</h2>
                <p className="short-text">Session cookie</p>
            </div>

            <div>
                <h2 className="important">The legal base of data processing:</h2>
                <p className="long-text">The e. point of GDPR 6th article 1st paragraph, taking into consideration the 24th and the 32nd article of GDPR and the 5th paragraph of year 2013. L. act regarding electronic information security of the state and municipalities, furthermore in the 3rd enclosure of the 41/2015. (VII. 15.) decree of Ministry of Internal Affair and in the 27th § 2nd paragraph of General Executive Regulations about the expected tasks in the 5th paragraph of year 2013. L. act regarding electronic information security of the state and municipalities defined technology security and safe information tools furthermore the demand of the classification into security class and security level.</p>
            </div>

            <div>
                <h2 className="important short-text">The goal of data processing:</h2>
                <p className="short-text">The proper functioning of the website.</p>
            </div>

            <div>
                <h2 className="important">The period of the data processing:</h2>
                <p className="short-text">The period till the end of the concerned website visit session.</p>
            </div>             
      
        </div>
    );
}

export default GDPREng;